 import { ReactNode } from "react";
 
 // Product page data structure
 export interface ProductPage {
   slug: string;
   seoKey: string;
   title: string;
   subtitle: string;
   description: string;
   canonicalUrl: string;
   keywords: string;
   breadcrumbLabel: string;
   features: string[];
   schemaType: "Product" | "SoftwareApplication";
   // Component keys for dynamic rendering
   componentSet: "ai-agent-plattform" | "ai-agent" | "ai-knowledge-base" | "ai-automation-workflows" | "unified-inbox" | "analytics" | "enterprise-hosting";
 }
 
 export const productPages: ProductPage[] = [
   {
     slug: "ai-agent-plattform",
     seoKey: "aiAgentPlattform",
     title: "AI Agent Plattform – Skalierbare KI-Infrastruktur | Chathero",
     subtitle: "Die zentrale KI-Schicht für Kundenkommunikation",
     description: "Die Chathero AI Agent Plattform bietet zentrale Wissensbasis, Multi-Channel-Orchestrierung und nahtlose Integrationen. Enterprise-Power für den Mittelstand.",
     canonicalUrl: "https://chathero.ai/produkte/ai-agent-plattform",
     keywords: "AI Plattform, KI Infrastruktur, Wissensbasis, Multi-Channel, CRM Integration, Enterprise AI, Chatbot Plattform",
     breadcrumbLabel: "AI Agent Plattform",
     features: ["Zentrale Wissensbasis", "Multi-Channel-Orchestrierung", "CRM-Integration", "DSGVO-konform"],
     schemaType: "Product",
     componentSet: "ai-agent-plattform",
   },
   {
     slug: "ai-agent",
     seoKey: "aiAgent",
     title: "AI Agents & KI Assistenten – Intelligente Kundenkommunikation | Chathero",
     subtitle: "Intelligente Kundenkommunikation - gesteuert, skalierbar, rollenbasiert",
     description: "Spezialisierte AI Agents für Marketing, Sales, Service und Commerce – 24/7 verfügbar, mehrsprachig, markenkonform.",
     canonicalUrl: "https://chathero.ai/produkte/ai-agent",
     keywords: "AI Agent, KI Assistent, Chatbot Marketing, Sales Automation, Kundenservice Bot, Commerce AI, WhatsApp Bot",
     breadcrumbLabel: "AI Agent",
     features: ["Marketing Agent", "Sales Agent", "Service Agent", "Commerce Agent", "Multi-Channel", "Branding & Persona"],
     schemaType: "Product",
     componentSet: "ai-agent",
   },
   {
     slug: "ai-knowledge-base",
     seoKey: "aiKnowledgeBase",
     title: "KI-Wissensdatenbank – Zentrale Wissensbasis für AI Agents | Chathero",
     subtitle: "Das Fundament für konsistente, skalierbare KI-gestützte Kundenkommunikation",
     description: "Die Chathero KI-Wissensdatenbank bündelt Unternehmens-, Service- und Produktwissen in einer KI-optimierten Struktur als gemeinsame Wissensbasis für alle AI Agents.",
     canonicalUrl: "https://chathero.ai/produkte/ai-knowledge-base",
     keywords: "KI Wissensdatenbank, Knowledge Base, AI Wissensbasis, Content Knowledge, Product Knowledge, Wissensverwaltung, Chatbot Wissen",
     breadcrumbLabel: "KI-Wissensdatenbank",
     features: ["Content Knowledge", "Product Knowledge", "Zentrale Steuerung", "Multi-Source Import", "DSGVO-konform"],
     schemaType: "Product",
    componentSet: "ai-knowledge-base",
  },
  {
    slug: "ai-automation-workflows",
    seoKey: "aiAutomationWorkflows",
    title: "AI Workflows & Automation – KI-gestützte Prozessautomatisierung | Chathero",
    subtitle: "Von KI-Dialogen zu messbaren Prozessen und Ergebnissen",
    description: "Chathero AI Workflows & Automation verbinden KI-gestützte Kommunikation mit Ihren Geschäftsprozessen. Automatisiert, nachvollziehbar und skalierbar.",
    canonicalUrl: "https://chathero.ai/produkte/ai-automation-workflows",
    keywords: "AI Workflows, KI Automatisierung, Prozessautomatisierung, CRM Workflow, Lead Automation, Service Automation, Commerce Automation",
    breadcrumbLabel: "AI Workflows & Automation",
    features: ["Lead & CRM-Workflows", "Service-Ticket-Automation", "Commerce-Prozesse", "End-to-End-Workflows", "DSGVO-konform"],
    schemaType: "Product",
    componentSet: "ai-automation-workflows",
  },
  {
      slug: "unified-inbox",
      seoKey: "unifiedInbox",
      title: "Unified Inbox – Zentrale Steuerzentrale für Kundenkommunikation | Chathero",
      subtitle: "Die zentrale Steuerzentrale für KI-gestützte und menschliche Kundenkommunikation",
      description: "Die Chathero Unified Inbox vereint alle Kommunikationskanäle, Live-Chat sowie Ihr Team in einer Oberfläche – strukturiert, steuerbar und skalierbar.",
      canonicalUrl: "https://chathero.ai/produkte/unified-inbox",
      keywords: "Unified Inbox, Kundenkommunikation, Live Chat, Ticketing, KI Posteingang, WhatsApp Business, Webchat, Team Inbox",
      breadcrumbLabel: "Unified Inbox",
      features: ["Unified Inbox", "KI-Dialogsteuerung", "Live-Agent-Übergabe", "Ticketing", "Team-Management"],
    schemaType: "Product",
    componentSet: "unified-inbox",
  },
  {
    slug: "analytics",
    seoKey: "analytics",
    title: "AI Analytics – KI-Performance messen & optimieren | Chathero",
    subtitle: "Volle Transparenz über Performance, Qualität und Prozesse",
    description: "Mit Chathero AI Analytics messen und steuern Sie die Performance Ihrer AI Assistants in Echtzeit. Interaktionen analysieren, KI-Qualität optimieren, Prozesse effizienter gestalten.",
    canonicalUrl: "https://chathero.ai/produkte/analytics",
    keywords: "AI Analytics, KI Performance, Chatbot Analytics, KI-Qualität, Automatisierungsquote, Dashboard, KI-Monitoring",
    breadcrumbLabel: "AI Analytics",
    features: ["Performance-Messung", "Qualitätsmonitoring", "Prozessoptimierung", "Nachfrageanalyse", "Echtzeit-Dashboard"],
    schemaType: "Product",
    componentSet: "analytics",
  },
  {
    slug: "enterprise-hosting",
    seoKey: "enterpriseHosting",
    title: "Enterprise Hosting – On-Premise & Private Cloud AI | Chathero",
    subtitle: "Ihre KI. Ihre Infrastruktur. Ihre Regeln.",
    description: "Chathero Enterprise Hosting: AI Agents in Ihrer eigenen Infrastruktur oder privaten Cloud. Volle Datenkontrolle, individuell skalierbar.",
    canonicalUrl: "https://chathero.ai/produkte/enterprise-hosting",
    keywords: "Enterprise Hosting, On-Premise AI, Private Cloud, Self-Hosted AI, Enterprise AI, Custom Deployment",
    breadcrumbLabel: "Enterprise Hosting",
    features: ["On-Premise Deployment", "Private Cloud", "Custom Modelle", "Individuelle Skalierung"],
    schemaType: "Product",
    componentSet: "enterprise-hosting",
  },
];
 
 export const getProductPageBySlug = (slug: string): ProductPage | undefined => {
   return productPages.find((page) => page.slug === slug);
 };
 
 export const getAllProductSlugs = (): string[] => {
   return productPages.map((page) => page.slug);
 };